<!-- Rows are permission-filtered server-side - refetch when the View All
     Company Objects toggle flips. -->
<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="feeds-grid"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
  [refreshOnCompanyObjectsToggle]="true"
></app-data-grid>
